import { render, staticRenderFns } from "./AnalisiMenuNavbar.vue?vue&type=template&id=681ec4cc&scoped=true&"
import script from "./AnalisiMenuNavbar.vue?vue&type=script&lang=js&"
export * from "./AnalisiMenuNavbar.vue?vue&type=script&lang=js&"
import style0 from "./AnalisiMenuNavbar.vue?vue&type=style&index=0&id=681ec4cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681ec4cc",
  null
  
)

export default component.exports